export default __webpack_public_path__ + "static/cloud-2-6f07e412ea4881fb4a5fbf1ac1a8b578.png";